export default {"src":"/_next/static/media/success.23cf24d5.svg","height":1080,"width":1080,"blurWidth":0,"blurHeight":0};